// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b3c96e32","453":"8b0871f7"}[chunkId] + ".chunk.js";
};